import { loggerOtel } from "opentelemetry";
import * as logsAPI from '@opentelemetry/api-logs';

export const errorLog = (message: string, error: Error | any) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : "No stack trace available";

  loggerOtel.emit({
    severityNumber: logsAPI.SeverityNumber.ERROR,
    severityText: "ERROR",
    body: `${message}: ${errorMessage}\nStack Trace:\n${errorStack}`,
    attributes: { "log.type": "LogRecord" },
  });
};

export const fatalLog = (message: string, error: Error | any) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : "No stack trace available";

  loggerOtel.emit({
    severityNumber: logsAPI.SeverityNumber.FATAL,
    severityText: "FATAL",
    body: `${message}: ${errorMessage}\nStack Trace:\n${errorStack}`,
    attributes: { "log.type": "LogRecord" },
  });
};
